import { createTheme } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { BUTTON_VARIANTS, BUTTON_SIZES, INPUT_VARIANTS } from './theme/components';

const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#F49F08',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#838388',
        contrastText: '#FFFFFF',
      },
      info: {
        main: '#306D79',
        contrastText: '#FFFFFF',
      },
      error: {
        main: '#B3261E',
        contrastText: '#FFFFFF',
      },
      success: {
        main: '#34C759',
        contrastText: '#FFFFFF',
      },
      background: {
        default: '#F4F7F7',
        paper: '#FFFFFF',
      },
      text: {
        primary: '#101E01',
        secondary: '#666666',
        disabled: '#838388',
      },
      divider: '#79747E',
      action: {
        disabled: '#E3E3E4',
        disabledBackground: '#E3E3E4',
        hover: '#0A000000',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: {
        fontSize: '2.5rem',
        fontWeight: 500,
      },
      h2: {
        fontSize: '2rem',
        fontWeight: 500,
      },
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            border: '1px solid rgba(0, 0, 0, 0.06)',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.10), 0 12px 24px rgba(0, 0, 0, 0.12)',
            backgroundColor: '#FFFFFF',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: 8,
          },
        },
        defaultProps: {
          variant: BUTTON_VARIANTS.primary,
          size: BUTTON_SIZES.medium,
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: INPUT_VARIANTS.outlined,
          size: BUTTON_SIZES.small,
        },
      },
      MuiFormControl: {
        defaultProps: {
          variant: INPUT_VARIANTS.outlined,
          size: BUTTON_SIZES.small,
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
          },
        },
      },
    },
  },
  itIT
);

export default theme;
